import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { CaretRightOutlined } from '@ant-design/icons';
import ItemCard from '../Projects/ListProjects/ItemCard';
import { getLabel } from '../../views/project/project.helper';
import useProjectFilterByStage from './hooks/useProjectFilterByStage';
import './styles.scss';

const ProjectCardsList = ({
  isLoadingProjects,
  projectsGroupedByStages,
  projectStages,
  filterText,
  filter,
  onClickProject,
  setFormProjectVisible,
  formProjectVisible,
  setFormDeleteVisible,
  formDeleteVisible,
  filterResultsCount,
  setShowUnarchiveModal
}) => {
  const sortedProjects = useProjectFilterByStage(
    projectsGroupedByStages,
    filterText
  );
  const { t } = useTranslation();

  if (isLoadingProjects) {
    window.loader.show();
  } else {
    window.loader.hide();
  }

  if (!sortedProjects || !Object.keys(sortedProjects).length) {
    return null;
  }

  return Object.values(projectStages).map((stage) => {
    const projects = sortedProjects[stage.value];

    if (!projects || !projects.length) {
      return null;
    }

    return (
      <div className="sectionProjects" key={stage.value}>
        <Row gutter={24} className="section--project">
          <CaretRightOutlined />
          <span>{getLabel(t)(stage.value, filter)}</span>
        </Row>
        <Row gutter={24} className="divProjects">
          {projects.map((project) => (
            <ItemCard
              onClickProject={onClickProject}
              key={project.id}
              t={t}
              project={project}
              setFormProjectVisible={setFormProjectVisible}
              setFormDeleteVisible={setFormDeleteVisible}
              formProjectVisible={formProjectVisible}
              formDeleteVisible={formDeleteVisible}
              setShowUnarchiveModal={setShowUnarchiveModal}
              analytics={{
                search_text: filterText,
                results_count: filterResultsCount
              }}
            />
          ))}
        </Row>
      </div>
    );
  });
};

ProjectCardsList.propTypes = {
  isLoadingProjects: PropTypes.bool,
  projectsGroupedByStages: PropTypes.object,
  projectStages: PropTypes.object,
  filterText: PropTypes.string,
  filter: PropTypes.string,
  onClickProject: PropTypes.func.isRequired,
  setFormProjectVisible: PropTypes.func,
  formProjectVisible: PropTypes.bool,
  setFormDeleteVisible: PropTypes.func,
  formDeleteVisible: PropTypes.bool,
  filterResultsCount: PropTypes.number,
  setShowUnarchiveModal: PropTypes.func
};

export default ProjectCardsList;
